import { BrowserModule } from '@angular/platform-browser';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatNativeDateModule, MatOptionModule, MatRippleModule, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { HttpClientModule } from '@angular/common/http';
import { VoucherEntryComponent } from './voucher-entry/voucher-entry.component';
import { HeadsComponent } from './heads/heads.component';
import { AccountsComponent } from './accounts/accounts.component';
import { RecentVouchersComponent } from './recent-vouchers/recent-vouchers.component';
import { LedgerRecordComponent } from './ledger-record/ledger-record.component';
import { from } from 'rxjs';
import { BalanceSheetComponent } from './balance-sheet/balance-sheet.component';
//import { Ng2SmartTableModule } from 'ng2-smart-table';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CRDBPipe } from './pipe/crdb/crdb.pipe';
import { DailyStockComponent } from './daily-stock/daily-stock.component';
import { ProfitandLossComponent } from './profitand-loss/profitand-loss.component';
import { RprtCreateComponent } from './rprt-create/rprt-create.component';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import {FormControl} from '@angular/forms';
import * as _moment from 'moment';
import { ProductionModule } from './production/production.module';
import { InventoryModule } from './inventory/inventory.module';
import { PipeModuleModule } from './pipe/pipe-module/pipe-module.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TrialBalanceComponent } from './trial-balance/trial-balance.component';
import { GSTR3BComponent } from './gstr3-b/gstr3-b.component';
import { ReconciliationComponent } from './reconciliation/reconciliation.component';
import { AccountReportsComponent } from './account-reports/account-reports.component';
// import { EmployeeComponent } from './employee/employee.component';
// import { AddEmployeeComponent } from './add-employee/add-employee.component';
// import { PayrollComponent } from './payroll/payroll.component';
// import { AttendanceComponent } from './attendance/attendance.component';
// import { EmployeeSettingComponent } from './employee-setting/employee-setting.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatRadioModule} from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { ReportsModule } from './inventory/reports/reports.module';
 import { LedgersComponent } from './ledgers/ledgers.component';
import { FinancialYearcountComponent } from './financial-yearcount/financial-yearcount.component';
import { VoucherPrintComponent } from './Printables/Voucher/voucher-print/voucher-print.component';
import { LedgerRecordPrintComponent } from './Printables/ledger-record-print/ledger-record-print.component';
import { TranjectionsPrintComponent } from './Printables/Tranjections/tranjections-print/tranjections-print.component';
import { VoucherSearchComponent } from './voucher-search/voucher-search.component'
import { PrintComponent } from './Printables/BalanceSheet/print/print.component';
import { PrintProfitLossComponent } from './Printables/ProfitLoss/print-profit-loss/print-profit-loss.component';
import { BankReconciliationPrintComponent } from './Printables/bank-reconciliation-print/bank-reconciliation-print.component';
import { HeadRecordComponent } from './head-record/head-record.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ItemEntryComponent } from './inventory/item-entry/item-entry.component';
import { SalesSummaryComponent } from './sales-summary/sales-summary.component';
import { TasksModule } from './Tasks/tasks.module';
import { JobcardPrintComponent } from './Printables/jobcard-print/jobcard-print.component';
import { LedgerEntryComponent } from './ledger-entry/ledger-entry.component';
import { PayrollModule } from './payroll/payroll.module';
import { NumbersOnlyDirective } from './Directive/numbers-only.directive';
import { TwoDecimalNumberDirective } from './Directive/two-decimal-number.directive';
import {InvoiceStatusComponent } from './invoice-status/invoice-status.component';
import { PaymentReceiptComponent } from './Printables/payment-receipt/payment-receipt.component'
import { AmountInWordPipe } from './pipe/amountInWord/amount-in-word.pipe'
import { ProductionReportsModule } from './production/production-reports/production-reports.module';
import { BomPrintComponent } from './Printables/bom-print/bom-print.component';
import { BasicPrdPrintComponent } from './Printables/basic-prd-print/basic-prd-print.component';
import { FindCompComponent } from './find-comp/find-comp.component';
import { LZStringModule } from 'ng-lz-string';
import { SuggestProfileComponent } from './suggest-profile/suggest-profile.component';
import { ProjectsModule } from './projects/projects.module';
import { ModuleTrainingComponent } from './module-training/module-training.component';
import { DayBookComponent } from './day-book/day-book.component';
import { AccountsSettingsComponent } from './accounts-settings/accounts-settings.component';
import { AccountsGroupPrefComponent } from './accounts-group-pref/accounts-group-pref.component';
import { SetAcctStartDateComponent } from './set-acct-start-date/set-acct-start-date.component';
import { CfgGstLedgersComponent } from './cfg-gst-ledgers/cfg-gst-ledgers.component';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YY',
  },
  display: {
    dateInput: 'DD-MMM-YY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD-MMM-YY',
    monthYearA11yLabel: 'DD-MMM-YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent,
    VoucherEntryComponent,
    HeadsComponent,
    AccountsComponent,
    RecentVouchersComponent,
    LedgerRecordComponent,
    BalanceSheetComponent,
    CRDBPipe,
    DailyStockComponent,
    ProfitandLossComponent,
    RprtCreateComponent,
    TrialBalanceComponent,
    GSTR3BComponent,
    ReconciliationComponent,
    AccountReportsComponent,
    // PayrollComponent,
    // AttendanceComponent,
    FinancialYearcountComponent,
    VoucherPrintComponent,
    LedgersComponent,
    LedgerRecordPrintComponent,
    TranjectionsPrintComponent,
    PrintComponent,
    PrintProfitLossComponent,
    VoucherSearchComponent,
    BankReconciliationPrintComponent,
    HeadRecordComponent,
    SalesSummaryComponent,
    JobcardPrintComponent,
    LedgerEntryComponent,
    NumbersOnlyDirective,
    TwoDecimalNumberDirective,
    InvoiceStatusComponent,
    AmountInWordPipe,
    PaymentReceiptComponent,
    BomPrintComponent,
    BasicPrdPrintComponent,
    FindCompComponent,
    SuggestProfileComponent,
    ModuleTrainingComponent,
    DayBookComponent,
    AccountsSettingsComponent,
    AccountsGroupPrefComponent,
    SetAcctStartDateComponent,
    CfgGstLedgersComponent
  ],
  imports: [
    BrowserModule,
      AppRoutingModule,
      NgbModule,
      MatDatepickerModule,
      MatInputModule,
      MatNativeDateModule,
      BrowserAnimationsModule,
      FormsModule,
      HttpClientModule,
      ReactiveFormsModule,
      MatRippleModule,
      MatTableModule,
      MatFormFieldModule,
      MatSelectModule ,
      ProductionModule,
      InventoryModule,
      PipeModuleModule,
      MatProgressSpinnerModule,
      MatAutocompleteModule,
      MatPaginatorModule,
      MatRadioModule,
      MatSortModule,
      ReportsModule,
      MatSelectModule,
      MatOptionModule,
      MatProgressSpinnerModule,
      MatDatepickerModule,
      NgxSpinnerModule,
      TasksModule,
      PayrollModule,
      ProductionReportsModule,
      LZStringModule,
      ProjectsModule,
      MatDialogModule,
      MatButtonModule,
  ],
  entryComponents: [AccountsGroupPrefComponent,VoucherEntryComponent,FinancialYearcountComponent,AccountsComponent,InvoiceStatusComponent, SuggestProfileComponent, ModuleTrainingComponent, SetAcctStartDateComponent, CfgGstLedgersComponent ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-IN' }, {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    // LZStringService,
    NgbActiveModal
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 

}

export class DatepickerFormatsExample {
  date = new FormControl(moment());
}



